const toolTips = {

    wraps: document.querySelectorAll('.jsToolTip') as NodeListOf<HTMLElement>,

    init() {
        this.toggleToolTips();
    },

    toggleToolTips() {
        this.wraps.forEach(wrap => {
            const singleTip = wrap.querySelector('.jsToolTipWrap');

            wrap.addEventListener('click', () => {
            if(wrap.dataset.open === 'false') {
                wrap.dataset.open = 'true';
                singleTip?.classList.add('activeClass');
            } else {
                wrap.dataset.open = 'false';
                singleTip?.classList.remove('activeClass');
            }
            })
        });
    }


}

export default toolTips;